import fieldUtils from "../../utils/step.fields.utils";
import config from "../../config";
import products from "../../utils/products";

const secondOccupation = () => {
    return [
        {
            key: `occupation_1_type`,
        },
    ];
};

const drivers = (n) => {
    const result = [
        {...fieldUtils.driver_x_name(n)},
        {...fieldUtils.driver_x_date_of_birth(n)}
    ];

    if (n < config[products.van].drivers) {
        result.push({
            ...fieldUtils.driver_x_more(n),
            label: 'Are any additional drivers required on the policy?',
            children: drivers(n + 1),
            required_children: value => value === true
        });
    }
    return result;
};

const step_schema_motor_home = [
    // vehicle
    {
        key: 'vrm',
    },
    {
        key: 'make',
    },
    {
        key: 'model',
    },
    {
        key: 'year',
    },
    {
        key: 'engine'
    },
    {
        key: 'value',
    },
    // driver
    {
        key: 'driver_details',
        info: 'Details',
        extra_children: [
            {
                key: 'title',
                variant: 'inline'
            },
            {key: 'first_name'},
            {key: 'last_name'}
        ]
    },
    {
        key: 'telephone',
    },
    {
        key: 'email',
    },
    {
        key: 'date_of_birth',
    },
    {
        key: 'postcode',
    },
    {
        key: 'address1',
    },
    {
        key: 'address2',
    },
    {
        key: 'address3',
    },
    {
        key: 'address4',
    },
    {
        key: 'city',
    },
    {
        key: 'licence_type',
    },
    {
        key: 'licence_date',
    },
    {
        key: 'employment_status',
        children: [
            {
                label: `What is the driver's primary occupation?`,
                key: 'occupation_0_type',
                required_if: parent_value => parent_value === 'employed' || parent_value === 'self employed',
            },
            {
                key: 'occupation_0_more',
                label: 'Does the driver have a secondary occupation?',
                children: secondOccupation(),
                required_children: value => value === true,
                required_if: parent_value => parent_value === 'employed' || parent_value === 'self employed',
            },
        ],
    },
    {
        key: 'has_another_vehicle',
        value: true,
    },
    {
        key: 'has_another_driver_more',
        label: 'Are any additional drivers required on the policy?',
        children: drivers(0),
        required_children: value => value === true
    },
    // policy
    {
        key: 'cover_date',
    },
    {
        key: 'cover_duration',
    },
    // marketing
    {
        key: 'marketing',
        extra_children: [
            {
                key: 'marketing_phone',
            },
            {
                key: 'marketing_email',
            },
            {
                key: 'marketing_sms',
            },
        ],
    },
    {
        key: 'end',
    },
];
export default step_schema_motor_home;
